import { format } from "date-fns";

// helper method for getting exact date and time in Date format
export const getFormattedDate = (date: Date) => {
  const inputDate = new Date(date);
  // Format the parsed date in the 'yyyy-MM-dd' default format
  return format(inputDate, "yyyy-MM-dd");
};
